module.exports = __webpack_public_path__ + "static/media/Apple iPad Pro 13\" Silver - Portrait.6a219322.png";